/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import ProgressExample from '../examples/Progress';
const ProgressExampleSource = require('!!raw-loader!../examples/Progress');
import ProgressColorExample from '../examples/ProgressColor';
const ProgressLabelRightExampleSource = require('!!raw-loader!../examples/ProgressLabelRight');
import ProgressLabelRightExample from '../examples/ProgressLabelRight';
const ProgressColorExampleSource = require('!!raw-loader!../examples/ProgressColor');
import ProgressLabelsExample from '../examples/ProgressLabels';
const ProgressLabelsExampleSource = require('!!raw-loader!../examples/ProgressLabels');
import ProgressAnimatedExample from '../examples/ProgressAnimated';
const ProgressAnimatedExampleSource = require('!!raw-loader!../examples/ProgressAnimated');
import ProgressStripedExample from '../examples/ProgressStriped';
const ProgressStripedExampleSource = require('!!raw-loader!../examples/ProgressStriped');
import ProgressMultiExample from '../examples/ProgressMulti';
const ProgressMultiExampleSource = require('!!raw-loader!../examples/ProgressMulti');
import ProgressMaxExample from '../examples/ProgressMax';
const ProgressMaxExampleSource = require('!!raw-loader!../examples/ProgressMax');
import ProgressSizesExample from '../examples/ProgressSizes';
const ProgressSizesExampleSource = require('!!raw-loader!../examples/ProgressSizes');
import StepProgressExample from '../examples/StepsProgress';
const StepProgressExampleSource = require('!!raw-loader!../examples/StepsProgress');
export default class ProgressPage extends React.Component {
    render() {
        return (<div>
                <Helmet title="Progress"/>
                <h3>Progress</h3>
                <h4>Default course progress</h4>
                <div className="docs-example docs-example--progress">
                    <div>
                        <ProgressLabelRightExample />
                    </div>
                </div>
                <pre>
                    <PrismCode className="language-jsx">{ProgressLabelRightExampleSource}</PrismCode>
                </pre>
                <h4>Progress sizes</h4>
                <div className="docs-example docs-example--progress">
                    <div>
                        <ProgressSizesExample />
                    </div>
                </div>
                <pre>
                    <PrismCode className="language-jsx">{ProgressSizesExampleSource}</PrismCode>
                </pre>
                <h4>Progress</h4>
                <div className="docs-example docs-example--progress">
                    <ProgressExample />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{ProgressExampleSource}</PrismCode>
                </pre>
                <h5>Properties</h5>
                <pre>
                    <PrismCode className="language-jsx">
                        {`Progress.propTypes = {
  multi: PropTypes.bool,
  bar: PropTypes.bool, // used in combination with multi
  tag: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  max: PropTypes.oneOf([
    PropTypes.string,
    PropTypes.number,
  ]),
  animated: PropTypes.bool,
  striped: PropTypes.bool,
  color: PropTypes.string,
  className: PropTypes.string,
  barClassName: PropTypes.string // used to add class to the inner progress-bar element
};

Progress.defaultProps = {
  tag: 'progress',
  value: 0,
  max: 100,
};`}
                    </PrismCode>
                </pre>

                <h4>Steps Progress</h4>
                <p>this progress allows you to visually divide the progress bar according to the individual steps.</p>
                <div className="docs-example docs-example--progress">
                    <StepProgressExample />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{StepProgressExampleSource}</PrismCode>
                </pre>
                <h5>Properties</h5>
                <pre>
                    <PrismCode className="language-jsx">
                        {`type Props = {|
    step: number,
    maxStep: number,
    className: string,
    small: boolean,
|};`}
                    </PrismCode>
                </pre>

                <h4>Color Variants</h4>
                <div className="docs-example docs-example--progress">
                    <div>
                        <ProgressColorExample />
                    </div>
                </div>
                <pre>
                    <PrismCode className="language-jsx">{ProgressColorExampleSource}</PrismCode>
                </pre>
                <h4>Labels</h4>
                <div className="docs-example docs-example--progress">
                    <div>
                        <ProgressLabelsExample />
                    </div>
                </div>
                <pre>
                    <PrismCode className="language-jsx">{ProgressLabelsExampleSource}</PrismCode>
                </pre>

                <h4>Striped</h4>
                <div className="docs-example docs-example--progress">
                    <div>
                        <ProgressStripedExample />
                    </div>
                </div>
                <pre>
                    <PrismCode className="language-jsx">{ProgressStripedExampleSource}</PrismCode>
                </pre>

                <h4>Animated</h4>
                <p>
                    The <code>animated</code> prop also adds the <code>striped</code> prop; there is no need to pass
                    both.
                </p>
                <div className="docs-example docs-example--progress">
                    <div>
                        <ProgressAnimatedExample />
                    </div>
                </div>
                <pre>
                    <PrismCode className="language-jsx">{ProgressAnimatedExampleSource}</PrismCode>
                </pre>

                <h4>Multiple bars / Stacked</h4>
                <div className="docs-example docs-example--progress">
                    <div>
                        <ProgressMultiExample />
                    </div>
                </div>
                <pre>
                    <PrismCode className="language-jsx">{ProgressMultiExampleSource}</PrismCode>
                </pre>

                <h4>Max value</h4>
                <div className="docs-example docs-example--progress">
                    <div>
                        <ProgressMaxExample />
                    </div>
                </div>
                <pre>
                    <PrismCode className="language-jsx">{ProgressMaxExampleSource}</PrismCode>
                </pre>
            </div>);
    }
}
